import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import {
  CommunicationMessage,
  Illustrations,
  IllustrationSize,
} from '../../../Communication';
import { ThemeMode, useProviderTheme } from '../../../hooks';

export interface NoAbsencesFoundProps {
  searchText: string;
}

export const NoAbsencesFound: FC<NoAbsencesFoundProps> = ({ searchText }) => {
  const { t } = useTranslation();
  const theme = useProviderTheme();
  const content =
    searchText !== '' ? (
      <CommunicationMessage
        illustration={Illustrations.Empty}
        illustrationSize={IllustrationSize.Medium}
        headline={t('classbook:absences:no_filter_matches_headline', { defaultValue: 'Keine Schüler gefunden' })}
        text={t('classbook:absences:no_filter_matches_text', { defaultValue: 'Zu dem von Ihnen eingegebenen Suchbegriff wurden keine Schüler gefunden' })}
        useDarkIllustration={theme.mode === ThemeMode.Dark}
      />
    ) : (
      <CommunicationMessage
        illustration={Illustrations.Empty}
        illustrationSize={IllustrationSize.Medium}
        headline={t('classbook:absences:no_students_headline', { defaultValue: 'Keine Schüler vorhanden' })}
        text={t('classbook:absences:no_students_text', { defaultValue: 'In dem von Ihnen ausgewählten Kurs existieren keine Schüler' })}
        useDarkIllustration={theme.mode === ThemeMode.Dark}
      />
    );

  return <>{content}</>;
};
